import React, { useContext } from 'react';
import { ICreateModifierContext, CreateModifierContext } from '../../../createModifierState/createModifierContext';
import { MenuTranslationForm } from 'components/TranslationForm/MenuTranslationForm';

interface ITranslationsForm {
	isVisible: boolean;
}

const TranslationsForm: React.FC<ITranslationsForm> = ({ isVisible }) => {
	const {
		setFetchedTranslations,
		setTranslationTab,
		changeNameTranslation,
		changeDescriptionTranslation,
		selectedCustomer,
		translations,
		selectedTranslationTab,
	} = useContext<ICreateModifierContext>(CreateModifierContext);
	return (
		<MenuTranslationForm
			setFetchedTranslations={setFetchedTranslations}
			setTranslationTab={setTranslationTab}
			changeNameTranslation={changeNameTranslation}
			changeDescriptionTranslation={changeDescriptionTranslation}
			isVisible={isVisible}
			IDSelectedCustomer={selectedCustomer}
			translations={translations}
			selectedTranslationTab={selectedTranslationTab}
		/>
	);
};

export default TranslationsForm;
